<template>
  <div id="vessel-history">
    <vx-tooltip class="customizer-btn-vessel-history" text="History vessel" position="left">
      <vs-button
        v-if="collapsed"
        color="warning"
        icon-pack="feather"
        icon="icon-chevrons-left"
        style="border-top-right-radius: 0;border-bottom-right-radius: 0;"
        @click="setCollapsed(false)"
      ></vs-button>
      <vs-button
        v-else
        color="primary"
        icon-pack="feather"
        icon="icon-book-open"
        style="border-top-right-radius: 0;border-bottom-right-radius: 0;"
        @click.stop="active=!active"
      ></vs-button>
    </vx-tooltip>
    <vs-sidebar
      v-model="active"
      hidden-background
      position-right
      click-not-close
      class="items-no-padding"
    >
      <div class="h-full">
        <div class="customizer-header mt-6 flex items-center justify-between px-6">
          <div>
            <h4>History Vessel</h4>
          </div>
          <div class="flex">
            <div class="flex items-center px-2">
              <chevrons-right-icon
                size="1.5x"
                class="custom-class cursor-pointer"
                @click="setCollapsed(true)"
              ></chevrons-right-icon>
            </div>
            <feather-icon icon="XIcon" class="cursor-pointer" @click.stop="close"></feather-icon>
          </div>
        </div>
        <vs-divider class="mb-0"></vs-divider>
        <div class="mt-3 mr-2 ml-2">
          <vs-row vs-w="12" class="mb-3 m-0 p-0">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <vs-divider style="margin:0">
                <b>1. Search vessel</b>
              </vs-divider>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <vs-input
                v-model="nameOrmmsi"
                label-placeholder="MMSI,Name"
                placeholder="MMSI,Name"
                class="w-full"
                @keypress.enter="searchVessel()"
              />
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <center>
                <vs-button
                  class="mt-3 mb-3 w-full"
                  color="success"
                  type="relief"
                  icon-pack="feather"
                  icon="icon-search"
                  @click="searchVessel()"
                >Search vessel</vs-button>
              </center>
            </vs-col>
            <div v-if="selected.length">
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="12"
                vs-sm="12"
                vs-xs="12"
              >
                <vs-divider style="margin:0">
                  <b>2. Select date and time</b>
                </vs-divider>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="12"
                vs-sm="12"
                vs-xs="12"
              ></vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="start"
                vs-align="start"
                vs-lg="12"
                vs-sm="12"
                vs-xs="12"
              >
                <div>From</div>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="12"
                vs-sm="12"
                vs-xs="12"
              >
                <flat-pickr
                  :config="configdateTimePicker"
                  :maxDate="new Date().fp_incr(14)"
                  v-model="formdatetime"
                  placeholder="Date Time"
                  class="w-full inputDate"
                />
                <button class="m-0 p-3 xclose" @click="getdatefrom()">x</button>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="start"
                vs-align="start"
                vs-lg="12"
                vs-sm="12"
                vs-xs="12"
              >
                <div class="mt-4">To</div>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="12"
                vs-sm="12"
                vs-xs="12"
              >
                <flat-pickr
                  :config="configdateTimePicker"
                  v-model="todatetime"
                  placeholder="Date Time"
                  class="w-full inputDate"
                />
                <button class="m-0 p-3 xclose" @click="getdateTo()">x</button>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="start"
                vs-align="start"
                vs-lg="12"
                vs-sm="12"
                vs-xs="12"
              >
                <div class="mt-4">ความละเอียดข้อมูล</div>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="12"
                vs-sm="12"
                vs-xs="12"
              >
                <vs-select v-model="selectTimeIntervel" class="w-full vh-content">
                  <vs-select-item
                    v-for="(item,index) in frequencyData"
                    :key="index"
                    :value="item.time"
                    :text="item.name"
                  />
                </vs-select>
              </vs-col>

              <center>
                <vs-row class="vh-center">
                  <vs-button
                    class="mt-2 mb-2 vh-btn"
                    color="primary"
                    type="relief"
                    icon="search"
                    @click="getHistory()"
                  >Search History</vs-button>
                  <vs-button
                    :disabled="!showHistory"
                    class="mt-2 mb-2 vh-btn"
                    color="primary"
                    type="relief"
                    icon="description"
                    @click="viewReport()"
                  >View Report</vs-button>
                  <vs-button
                    icon="fullscreen"
                    type="relief"
                    class="mt-2 mb-2 vh-btn"
                    @click="onFullScreenBtn"
                  >Full Screen</vs-button>
                </vs-row>
              </center>
            </div>
          </vs-row>
        </div>
        <VesselController v-if="showHistory && max >= 1" :onChangeValue="changeValue" :max="max" />
        <center>
          <vs-alert
            :active="statusLoadingVessel"
            color="primary"
            style="width:90%;margin:8px"
            title="Loading...."
          >กำลังโหลดข้อมูลเรือ กรุณารอสักครู่...</vs-alert>
          <vs-alert
            :active="statusLoadingHistory"
            color="primary"
            style="width:90%;margin:8px"
            title="Loading...."
          >กำลังโหลดข้อมูลย้อนหลัง กรุณารอสักครู่...</vs-alert>
          <vs-alert color="danger" style="width:90%;margin:8px" title="Error">ไม่พบข้อมูลเรือ...</vs-alert>
        </center>
        <br />
        <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6 pr-2">
          <vs-table v-model="selected" :data="Datasuccess" @selected="handleSelected">
            <template slot="thead">
              <vs-th>MMSI</vs-th>
              <vs-th>Name</vs-th>
            </template>

            <template slot-scope="{data}">
              <tbody>
                <vs-tr v-for="(tr, indextr) in Datasuccess" :data="tr" :key="indextr">
                  <vs-td :data="data[indextr].mmsi">{{ data[indextr].mmsi }}</vs-td>
                  <vs-td :data="data[indextr].name">{{ data[indextr].name }}</vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </VuePerfectScrollbar>
      </div>
    </vs-sidebar>
  </div>
</template>
<script>
import axios from "axios";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import DatePicker from "vue2-datepicker";
import flatPickr from "vue-flatpickr-component";
import { mapState } from "vuex";
import { ChevronsRightIcon } from "vue-feather-icons";
import VesselController from "./../VesselController/VesselController.vue";
import "flatpickr/dist/flatpickr.css";
import { mobileDevice } from "./../../../utils";
import { API_GET_VESSELS, API_VESSEL_REPORT ,API_GET_ADMIN_VESSELS} from "./../../../constants/api";

export default {
  name: "VesselHistory",
  components: {
    VuePerfectScrollbar,
    DatePicker,
    flatPickr,
    VesselController,
    ChevronsRightIcon,
  },
  props: {
    callback: {
      type: Function,
      default() {},
    },
    onChangeValue: {
      type: Function,
      default() {},
    },
    max: {
      type: Number,
      default: 10,
    },
    onCloseHistory: {
      type: Function,
      default() {},
    },
    onLoadHistory: {
      type: Function,
      default() {},
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    onActive: {
      type: Function,
      default() {},
    },
    onFullScreen: {
      type: Function,
      default() {},
    },
    map: undefined,
  },
  data() {
    return {
      isMobileDevice: mobileDevice(),
      collapsed: false,
      selectTimeIntervel: 86400,
      statusSearchVessel: false,
      statusLoadingVessel: false,
      statusLoadingHistory: false,
      selected: [],
      nameOrmmsi: "",
      Datasuccess: [],
      formdatetime: null,
      todatetime: null,
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "d/m/Y H:i",
        maxDate: new Date(),
      },
      active: false,
      mmsi: "",
      name: "",
      accessEmail: "",
      accessToken: "",
      accessRole: "",
      dataHistory: {},
      showHistory: false,
    };
  },
  computed: {
    ...mapState({
      frequencyData: (state) => state.vesselHistory.intervel,
    }),
  },
  watch: {
    active(val) {
      this.resetData(val);
      if (val) {
        this.setCollapsed(!val);
      }
    },
    isActive(val) {
      if (!val) {
        this.active = false;
        this.collapsed = false;
      }
      this.resetData(val);
    },
    selectTimeIntervel(val, oldval) {
      if (val != oldval) {
        this.getHistory(val);
      }
    },
  },
  created() {
    this.accessEmail = localStorage.getItem("accessEmail");
    this.accessToken = localStorage.getItem("accessToken");
    this.accessRole = localStorage.getItem("userRole");
  },
  mounted() {
    this.getdate();
  },
  methods: {
    close() {
      this.onCloseHistory();
      // reset data
      this.active = false;
    },
    onFullScreenBtn() {
      this.onFullScreen();
    },
    handleSelected(tr) {
      this.nameOrmmsi = tr.mmsi;
      this.$vs.notify({
        title: `Selected ${tr.mmsi}`,
        text: `Name: ${tr.name}`,
      });
      // select vessel
      this.callback([tr]);
    },
    changeValue(val) {
      this.onChangeValue(val);
    },
    searchVessel() {
      this.statusLoadingVessel = true;
      let url
      this.accessRole == "ROLE_OBSERVE_EXCISE_TANKER" ? (url = API_GET_VESSELS()) : (url = API_GET_ADMIN_VESSELS());

      const accessEmail = localStorage.getItem("accessEmail");
      const accessToken = localStorage.getItem("accessToken");
      axios
        .get(url, {
          params: {
            "q[mmsi_or_name_cont]": this.nameOrmmsi,
            "q[ship_type_id_eq]": "",
            "q[navigation_status_id_eq]": "",
          },
          headers: {
            "X-User-Email": accessEmail,
            "X-User-Token": accessToken
          },
        })
        .then((response) => {
          if (this.nameOrmmsi == "") {
            this.Datasuccess = response.data;
          } else {
            this.Datasuccess = [];
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].mmsi != null) {
                this.Datasuccess.push(response.data[i]);
              }
            }
          }
        })
        .catch((error) => {
          console.log("vessel list API error:", error);
        })
        .finally(() => {
          this.statusLoadingVessel = false;
        });
    },
    getdate() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      // var locale = this.$i18n.locale;
      // if (locale == "th") {
      //   var yyyy = today.getFullYear() + 543 ;
      // } else {
      //   var yyyy = today.getFullYear();
      // }

      let formtime =
        String(parseInt(dd - 1)) + "/" + mm + "/" + yyyy + " " + "00:00";
      let totime =
        dd +
        "/" +
        mm +
        "/" +
        yyyy +
        " " +
        today.getHours() +
        ":" +
        today.getMinutes();
      this.formdatetime = formtime;
      this.todatetime = totime;
    },
    getdatefrom() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();

      let formtime =
        String(parseInt(dd - 1)) + "/" + mm + "/" + yyyy + " " + "00:00";
      this.formdatetime = formtime;
    },
    getdateTo() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();

      let totime =
        dd +
        "/" +
        mm +
        "/" +
        yyyy +
        " " +
        today.getHours() +
        ":" +
        today.getMinutes();
      this.todatetime = totime;
    },
    getHistory(val = undefined) {
      if (this.nameOrmmsi == "") {
        this.$vs.notify({
          title: "ผิดพลาด",
          text: "กรุณาเลือกเรือที่ต้องการจะดู History",
          position: "top-center",
          color: "danger",
        });
      } else {
        this.statusLoadingHistory = true;
        this.onLoadHistory(true);
        const interval = val || this.selectTimeIntervel;

        const url = API_VESSEL_REPORT();
        const accessEmail = localStorage.getItem("accessEmail");
        const accessToken = localStorage.getItem("accessToken");
        axios
          .get(url, {
            params: {
              utf8: "✓",
              "q[mmsi_cont]": this.selected.mmsi,
              "q[name_cont]": this.selected.name,
              record_time_gteq: this.formdatetime,
              record_time_lteq: this.todatetime,
              interval,
            },
            headers: {
              "X-User-Email": accessEmail,
              "X-User-Token": accessToken,
            },
          })
          .then((response) => {
            this.dataHistory = response.data;
            this.showHistory = true;
            if (
              response.data == null ||
              response.data == [] ||
              response.data == {} ||
              response.data == ""
            ) {
              this.$vs.notify({
                title: "ผิดพลาด",
                text: "ไม่พบข้อมูลในช่วงเวลานี้ กรุณาเรื่องช่วงเวลาใหม่",
                position: "top-center",
                color: "danger",
              });
            } else {
              localStorage.removeItem("detailReport");
              localStorage.setItem(
                "detailReport",
                JSON.stringify(response.data[0].url)
              );

              this.callback(response.data, interval);
            }
          })
          .catch((error) => {
            this.$vs.notify({
              title: "Danger",
              text: "Lorem ipsum dolor sit amet, consectetur",
              color: "danger",
            });
            console.log("Error call apis :", error);
          })
          .finally(() => {
            this.onLoadHistory(false);
            this.statusLoadingHistory = false;
          });
      }
    },
    viewReport() {
      if (this.dataHistory) {
        let routeData = this.$router.resolve({
          name: "DetailReport",
          query: { interval: this.selectTimeIntervel },
        });
        window.open(routeData.href, "_blank");
      }
    },
    setCollapsed(flag) {
      const elem = document.querySelector("#vessel-history");
      const sidebar = elem.getElementsByClassName("vs-sidebar");
      if (flag) {
        sidebar[0].style.width = "0vw";
      } else {
        sidebar[0].style.width = "350px";
      }
      this.collapsed = flag;
    },
    resetData(val) {
      if (!val) {
        this.statusSelected = false;
        this.selected = [];
        this.statusSearchVessel = false;
        this.statusLoadingVessel = false;
        this.statusLoadingHistory = false;
        this.nameOrmmsi = "";
        this.Datasuccess = [];
        this.formdatetime = null;
        this.todatetime = null;
        this.mmsi = "";
        this.name = "";
        this.accessEmail = "";
        this.accessToken = "";
        this.dataHistory = {};
        this.showHistory = false;
      } else {
        this.onActive();
      }
    },
  },
};
</script>

<style lang="scss">
#vessel-history {
  .vs-sidebar {
    position: fixed;
    z-index: 52000;
    width: 350px;
    max-width: 90vw;
  }
  @media screen and (max-width: 420px) {
    .h4,
    h4 {
      font-size: calc(14px + 6 * ((100vw - 420px) / 680));
    }
    .b,
    b {
      font-size: calc(12px + 6 * ((100vw - 420px) / 680));
    }
  }
}

.vh-text {
  padding-left: 16px;
  padding-bottom: 4px;
}

.vh-content {
  padding-bottom: 16px;
}

.customizer-btn-vessel-history {
  position: fixed;
  top: 36%;
  right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  z-index: 50000;
}

.scroll-area--customizer {
  height: calc(100% - 5rem);
  border-style: inset;
}

.scroll-area--detail {
  height: 200px;
  border-style: inset;
  padding-left: 10px;
  padding-right: 10px;
}

.vessel-img {
  width: 100%;
  height: 150px;
  border-style: solid gray;
  border-radius: 10px;
  margin-top: 3px;
}
.value-text {
  color: blue;
}
.title-text {
  font-weight: bold;
}

.inputDate {
  height: 36px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding-left: 10px;
}
.xclose {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.vh-center {
  justify-content: center;
}
.vh-btn {
  margin: 8px;
}
</style>
